import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as eggService from '@/services/egg';
import util from '@tencent/vft-common/util';
/**
 * 用于帮助快速创建Store里的 mutation 方法
 * @param {Array{string}} list
 */

export function createMutation() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var obj = {};

  var _iterator = _createForOfIteratorHelper(list),
      _step;

  try {
    var _loop = function _loop() {
      var key = _step.value;

      obj['save' + key[0].toUpperCase() + key.slice(1)] = function (state, value) {
        state[key] = value;
      };
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
}
export default {
  namespaced: true,
  state: function state() {
    return {
      myEggInfo: null,
      myShareCode: '',
      masterShareCode: '',
      masterEggInfo: null,
      masterUserInfo: null,
      shareCodeInfo: null,
      bumpEggRecord: [],
      fetchEggRecord: []
    };
  },
  mutations: _objectSpread({}, createMutation(['myEggInfo', 'myShareCode', 'masterShareCode', 'masterEggInfo', 'masterUserInfo', 'shareCodeInfo', 'bumpEggRecord', 'fetchEggRecord'])),
  actions: {
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var commit, dispatch, rootState, masterShareCode;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, dispatch = _ref.dispatch, rootState = _ref.rootState;
                masterShareCode = util.getUrlParam('shareCode');
                commit('saveMasterShareCode', masterShareCode);

                if (!rootState.isLogin) {
                  _context.next = 11;
                  break;
                }

                _context.next = 6;
                return Promise.all([dispatch('getMyEggInfo'), dispatch('getMyShareCode')]);

              case 6:
                if (!masterShareCode) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return dispatch('getMasterEggInfo');

              case 9:
                dispatch('getBumpEggRecord');
                dispatch('getFetchEggRecord');

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    getMyEggInfo: function () {
      var _getMyEggInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var commit, state, rootState, defaultValue, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit, state = _ref2.state, rootState = _ref2.rootState;
                defaultValue = {
                  egg_type: 0,
                  egg_count: 0,
                  special_id: ''
                };

                if (rootState.isLogin) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", commit('saveMyEggInfo', defaultValue));

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return eggService.getEggInfo();

              case 7:
                res = _context2.sent;
                commit('saveMyEggInfo', res.data);
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                commit('saveMyEggInfo', defaultValue);
                throw _context2.t0;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 11]]);
      }));

      function getMyEggInfo(_x2) {
        return _getMyEggInfo.apply(this, arguments);
      }

      return getMyEggInfo;
    }(),
    getMyShareCode: function () {
      var _getMyShareCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
        var commit, state, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref3.commit, state = _ref3.state;
                _context3.next = 3;
                return eggService.getShareCode();

              case 3:
                res = _context3.sent;
                commit('saveMyShareCode', res.data['share_code']);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getMyShareCode(_x3) {
        return _getMyShareCode.apply(this, arguments);
      }

      return getMyShareCode;
    }(),
    getMasterEggInfo: function () {
      var _getMasterEggInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4) {
        var commit, state, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit = _ref4.commit, state = _ref4.state;
                _context4.next = 3;
                return eggService.getInfoByShareCode(state.masterShareCode);

              case 3:
                res = _context4.sent;
                res.data.shareCode = state.masterShareCode;
                commit('saveMasterEggInfo', res.data.master_eggs_info);
                commit('saveMasterUserInfo', res.data.master_vip_info);
                commit('saveShareCodeInfo', res.data);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getMasterEggInfo(_x4) {
        return _getMasterEggInfo.apply(this, arguments);
      }

      return getMasterEggInfo;
    }(),
    receiveEgg: function () {
      var _receiveEgg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5) {
        var commit, dispatch, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit = _ref5.commit, dispatch = _ref5.dispatch;
                _context5.next = 3;
                return eggService.receiveEgg();

              case 3:
                res = _context5.sent;
                _context5.next = 6;
                return dispatch('getMyEggInfo');

              case 6:
                dispatch('getFetchEggRecord');
                return _context5.abrupt("return", res);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function receiveEgg(_x5) {
        return _receiveEgg.apply(this, arguments);
      }

      return receiveEgg;
    }(),
    bumpEgg: function () {
      var _bumpEgg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
        var commit, dispatch, state, rootState, res, award;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit = _ref6.commit, dispatch = _ref6.dispatch, state = _ref6.state, rootState = _ref6.rootState;
                _context6.next = 3;
                return eggService.bumpEgg(state.masterShareCode);

              case 3:
                res = _context6.sent;
                res = res.data;
                award = {
                  my: {
                    result: res.guest_lottery_info.property_result,
                    pic: res.guest_lottery_info.property_url,
                    avatar: rootState.userInfo.headurl,
                    nick: rootState.userInfo.nick,
                    name: res.guest_lottery_info.property_name
                  },
                  other: {
                    result: res.master_lottery_info.property_result,
                    pic: res.master_lottery_info.property_url,
                    avatar: state.masterUserInfo.master_url,
                    nick: state.masterUserInfo.master_name,
                    name: res.master_lottery_info.property_name
                  }
                };
                dispatch('getMyEggInfo');
                dispatch('getBumpEggRecord');
                return _context6.abrupt("return", award);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function bumpEgg(_x6) {
        return _bumpEgg.apply(this, arguments);
      }

      return bumpEgg;
    }(),
    getUnReadAwardList: function () {
      var _getUnReadAwardList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7) {
        var rootState, res, awardList;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                rootState = _ref7.rootState;
                _context7.next = 3;
                return eggService.getUnReadAwardList();

              case 3:
                res = _context7.sent;
                res = res.data;
                awardList = [];

                if (res && res.list && res.list.length > 0) {
                  awardList = res.list.map(function (item) {
                    return {
                      my: {
                        result: item.my.lottery_result,
                        pic: item.my.goods_url,
                        avatar: rootState.userInfo.headurl,
                        nick: rootState.userInfo.nick,
                        name: item.my.goods_name
                      },
                      other: {
                        result: item.friends.lottery_result,
                        pic: item.friends.goods_url,
                        avatar: item.friends.nick_url,
                        nick: item.friends.nick_name,
                        name: item.friends.goods_name
                      }
                    };
                  });
                }

                return _context7.abrupt("return", awardList);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getUnReadAwardList(_x7) {
        return _getUnReadAwardList.apply(this, arguments);
      }

      return getUnReadAwardList;
    }(),
    getBumpEggRecord: function () {
      var _getBumpEggRecord = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref8) {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commit = _ref8.commit;
                _context8.next = 3;
                return eggService.getMyRecord();

              case 3:
                res = _context8.sent;
                commit('saveBumpEggRecord', res.data.list);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getBumpEggRecord(_x8) {
        return _getBumpEggRecord.apply(this, arguments);
      }

      return getBumpEggRecord;
    }(),
    getFetchEggRecord: function () {
      var _getFetchEggRecord = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref9) {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                commit = _ref9.commit;
                _context9.next = 3;
                return eggService.getEggSourceList();

              case 3:
                res = _context9.sent;
                commit('saveFetchEggRecord', res.data.list);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getFetchEggRecord(_x9) {
        return _getFetchEggRecord.apply(this, arguments);
      }

      return getFetchEggRecord;
    }()
  }
};